package com.eladfinish.bible.contest.features.installTime.domain.model

sealed class TimeGateResult {

    data class Allowed(
        val event: InstallEvent,
    ) : TimeGateResult()

    data class Blocked(
        val reason: BlockReason,
        val remainingMillis: Long,
        val event: InstallEvent,
    ) : TimeGateResult()
}
